<template>
  <div class="register">
    <form class="register__form">
      <h1 class="title is-3">Registrierung</h1>
      <h2 class="title is-5">Kontakt- & Logindaten</h2>
      <div class="columns">
        <div class="column">
          <b-field>
            <template slot="label"
              >Name<span class="required">*</span></template
            >
            <b-input v-model="user.name" required />
          </b-field>
        </div>
        <div class="column">
          <b-field label="">
            <template slot="label">
              E-Mail<span class="required">*</span>
              <b-tooltip
                type="is-light"
                size="is-large"
                position="is-bottom"
                multilined
                label="Mit dieser E-Mail meldest du dich in deinem Konto an.
            Außerdem nutzen wir diese E-Mail zur allgemeinen Kommunikation und richten damit auf beim
 Erstellen eines neuen Servers ein Administrator-Konto ein."
              >
                <font-awesome-icon icon="question-circle"></font-awesome-icon>
              </b-tooltip>
            </template>
            <b-input v-model="user.email" type="email" required> </b-input>
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-field>
            <template slot="label"
              >Passwort<span class="required">*</span></template
            >
            <b-input
              v-model="user.password"
              type="password"
              password-reveal
              required
            />
          </b-field>
        </div>
        <div class="column">
          <b-field>
            <template slot="label"
              >Passwort<span class="required">*</span> (wiederholen)</template
            >
            <b-input
              v-model="user.password_confirmed"
              type="password"
              password-reveal
              required
            />
          </b-field>
        </div>
      </div>

      <hr />

      <h2 class="title is-5">Rechnungsdaten</h2>
      <div class="columns">
        <div class="column">
          <b-field>
            <template slot="label"
              >Rechnungsadresse<span class="required">*</span>
              <b-tooltip
                type="is-light"
                size="is-large"
                position="is-bottom"
                multilined
                label="Diese Adresse wird auf deiner Rechnung angegeben. Wenn du keinen Namen angibst, wird der Kontaktname von oben verwendet."
              >
                <font-awesome-icon
                  icon="question-circle"
                ></font-awesome-icon> </b-tooltip
            ></template>
            <b-input
              v-model="user.profile.billing_address"
              type="textarea"
              minlength="10"
              placeholder="Rechnungsadresse"
              required
            ></b-input>
          </b-field>
        </div>
        <div class="column">
          <b-field>
            <template slot="label"
              >Umsatzsteuer-ID
              <b-tooltip
                type="is-light"
                size="is-large"
                position="is-bottom"
                multilined
                label="Optional: Umsatzsteuer-ID für Unternehmer"
              >
                <font-awesome-icon
                  icon="question-circle"
                ></font-awesome-icon> </b-tooltip
            ></template>
            <b-input v-model="user.profile.billing_tax_id" />
          </b-field>
          <b-field v-show="!usePrimaryEmailForBilling">
            <template slot="label"
              >Rechnungs-E-Mail
              <b-tooltip
                type="is-light"
                size="is-large"
                position="is-bottom"
                multilined
                :required="!usePrimaryEmailForBilling"
                label="Mit dieser E-Mail meldest du dich in deinem ConfCloud Konto an.
            Außerdem richten wir auf jedem deiner ConfCloud-Server beim
            Erstellen ein Administrator-Konto mit dieser E-Mail ein."
              >
                <font-awesome-icon
                  icon="question-circle"
                ></font-awesome-icon> </b-tooltip
            ></template>
            <b-input v-model="user.profile.billing_email"> </b-input>
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <b-checkbox
              v-model="usePrimaryEmailForBilling"
              @input="toggleUsePrimaryEmailForBilling"
              >Rechnungen an meine Kontakt-E-Mail senden</b-checkbox
            >
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="buttons">
            <b-button
              type="is-success"
              icon-left="save"
              expanded
              @click="register"
              >Speichern</b-button
            >
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: "DashboardSettings",
  data() {
    return {
      user: {
        name: "",
        email: "",
        password: "",
        password_confirmed: "",
        profile: {
          billing_address: "",
          billing_vat_id: "",
          billing_email: ""
        }
      },
      usePrimaryEmailForBilling: true
    };
  },
  methods: {
    register() {
      if (this.usePrimaryEmailForBilling)
        this.user.profile.billing_email = this.user.email;

      this.$store.state.api
        .register(this.user)
        .then(response => {
          console.log(response);
          if (response.data.id) {
            this.$router.push("/registieren/naechste-schritte");
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    toggleUsePrimaryEmailForBilling(value) {
      if (value) {
        this.user.profile.billing_email = this.user.email;
      } else {
        this.user.profile.billing_email = "";
      }
    }
  }
};
</script>

<style scoped lang="scss">
.register {
  &__form {
    max-width: 30rem;
    margin: 0 auto;
  }
}
</style>
